import React from 'react';
import { Typography, Grid, IconButton, Icon, Button, Collapse } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';
import moment from 'moment';
import {
	FacebookShareButton,
	FacebookIcon,
	TwitterShareButton,
	TwitterIcon,
	WhatsappShareButton,
	WhatsappIcon,
	TelegramShareButton,
	TelegramIcon,
  } from "react-share";
//services
import EventoAPI from '../../../services/api/Evento';
//css
import './eventos.css';

export default class VerEventos extends React.Component {
	state = {
		titulo: null,
		descricao: null,
		data_inicio: null,
		data_fim: null,
		img: null,
		regulamento: null,
		data_cadastro:null,

		showShare:false,

		loading: true,
	}
	refreshEvento = () => {
		const { id } = this.props.match.params;
		const { history } = this.props;
		EventoAPI.get_web(id)
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					history.push('/404');
					return;
				}
				this.setState({
					titulo: res.titulo,
					descricao: res.descricao,
					data_inicio: res.data_inicio,
					data_fim: res.data_fim,
					img: res.url,
					data_cadastro: res.data_cadastro,
					regulamento: res.regulamento || null,

					loading:false,
				 })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshEvento()
	}
    render() {
		const { titulo, descricao, data_inicio, data_fim, img, data_cadastro, loading, regulamento, showShare } = this.state;
		const { PUBLIC_URL } = process.env;
		const { pathname } = this.props.location;
		const url = window.location.href;
		if( loading ){ return <LoadBox loading={loading} height="50vh" /> }
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>{`${titulo} - Eventos`}</title>
						<meta name="description" content={`${descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />
						<meta property="og:locale" content="pt_BR" />
						<meta property="og:url" content={`${PUBLIC_URL}${pathname}`} />
						<meta property="og:title" content={titulo} />
						<meta property="og:site_name" content="Shopping Norte Sul" />
						<meta property="og:description" content={`${descricao.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />
						<meta property="og:image" content={img} />
						<meta property="og:type" content="website" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Evento</Typography>
						</div>
					</div>
					<div className="pre_header" >
						<div className="pre_header__body" >
							<Grid container >
								<Grid item md={6} >
									<Typography variant="h5" >{titulo}</Typography>
									<Typography variant="h6" >De {moment(data_inicio).format('DD [de] MMMM [de] YYYY')} até {moment(data_fim).format('DD [de] MMMM [de] YYYY')}</Typography>
								</Grid>
								<Grid item md={6} className="pre_header__buttons" >
									<IconButton onClick={() => this.setState({showShare: !showShare})} >
										<Icon>share</Icon>
									</IconButton>
								</Grid>
								<Grid item md={12} xs={12} >
									<Collapse in={showShare} >
										<FacebookShareButton url={url}
															quote={titulo}
															className="button_share">
											<FacebookIcon size={32}
														round={true} />
										</FacebookShareButton>
										<TwitterShareButton url={url}
															quote={titulo}
															className="button_share">
											<TwitterIcon size={32}
														round={true} />
										</TwitterShareButton>
										<WhatsappShareButton url={url}
															quote={titulo}
															className="button_share">
											<WhatsappIcon size={32}
														round={true} />
										</WhatsappShareButton>
										<TelegramShareButton url={url}
															quote={titulo}
															className="button_share" >
											<TelegramIcon size={32}
														round={true} />
										</TelegramShareButton>
									</Collapse>
								</Grid>
							</Grid>
						</div>
					</div>
					<div className="app_content_page__row" >
						<Grid container spacing={32} >
							<Grid item md={12} >
								<Typography variant="subtitle1" className="publication_timing" gutterBottom >Publicado em: {moment(data_cadastro).format('DD [de] MMMM [de] YYYY [às] HH:mm')}</Typography>
							</Grid>
							<Grid item md={5} >
								<img className="public_image" src={img} alt={titulo} />
							</Grid>
							<Grid item md={7} >
								<Typography variant="h6" gutterBottom className="title_event" >Sobre:</Typography>
								<div className="text_event" dangerouslySetInnerHTML={{__html: descricao}} />
								{regulamento !== null && <div>
									<Button component="a" href={regulamento} target="_BLANK" variant="outlined" color="inherit" >Ver regulamento</Button>
								</div>}
							</Grid>
						</Grid>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/eventos/ver.js